import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { InstallationDetailsStore } from '@store';
import { MonetizationFeature, ViCarePlan } from '@vi-iot/client/index';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { matTooltipSetter } from '../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-vicare-plans-overlay',
  templateUrl: './vicare-plans-overlay.component.html',
  styleUrls: ['./vicare-plans-overlay.component.scss', '../vicare-plans.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViCarePlansOverlayComponent implements OnInit, OnDestroy {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  protected plans: ViCarePlan<MonetizationFeature>[];
  protected selectedPlan$ = new BehaviorSubject<ViCarePlan<MonetizationFeature>>(null);
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(protected installationDetailsStore: InstallationDetailsStore) {}

  ngOnInit(): void {
    this.installationDetailsStore.vicarePlansForInstallation$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((plans) => {
        this.plans = plans?.filter((plan) => !plan.isDefault);

        if (this.plans.length > 0) {
          this.selectPlan(this.plans[0]);
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  selectPlan(plan: ViCarePlan<MonetizationFeature>): void {
    this.selectedPlan$.next(plan);
  }
}
